import { useEffect, useState } from 'react';
import { authUnauthorizedEvent, startAuthSessionMonitor, type AuthUser } from './auth-api';

export function useAuthUser() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const clearUser = () => { setUser(null); setReady(true); };
    window.addEventListener(authUnauthorizedEvent, clearUser);
    const stop = startAuthSessionMonitor({
      onUserValidated: next => { setUser(next); setReady(true); },
      onValidationFinished: () => setReady(true),
    });
    return () => {
      stop();
      window.removeEventListener(authUnauthorizedEvent, clearUser);
    };
  }, []);
  return { user, ready };
}
